/* eslint-disable no-nested-ternary */
/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function item(theme, ownerState) {
    const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
    const { active, darkSidenav, sidenavColor, miniSidenav, darkMode } = ownerState;

    const { dark, text, transparent, white } = palette;
    const { xxl } = boxShadows;
    const { borderRadius } = borders;
    const { pxToRem, rgba } = functions;

    return {
        background: active ? rgba(palette[sidenavColor ?? "info"].main, sidenavColor ? 1 : 0.1) : transparent.main,
        color: () => {
            let result = text.main;

            if (darkMode) {
                if (darkSidenav) {
                    result = white.main
                }
                else{
                    result = dark.main
                }
            }
            else{
                if (darkSidenav) {
                    result = white.main
                }
            }

            return result;
        },
        display: miniSidenav ? "block" : "flex",
        alignItems: "center",
        width: "100%",
        padding: `${pxToRem(10.8)} ${pxToRem(16)} ${pxToRem(10.8)} ${pxToRem(16)}`,
        margin: `0 ${pxToRem(8)}`,
        borderRadius: borderRadius.md,
        cursor: "pointer",
        userSelect: "none",
        whiteSpace: "nowrap",
        boxShadow: active && darkSidenav ? xxl : "none",

        [breakpoints.up("xl")]: {
            boxShadow: () => {
                if (active) {
                    return darkSidenav ? xxl : "none";
                }

                return "none";
            },
            transition: transitions.create("box-shadow", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.shorter,
            }),
        },
    };
}

function itemIconBox(theme, ownerState) {
    const { transitions, borders, functions } = theme;
    const { darkSidenav, sidenavColor, active } = ownerState;

    const { borderRadius } = borders;
    const { pxToRem } = functions;

    return {
        color: "inherit",
        minWidth: pxToRem(32),
        minHeight: pxToRem(32),
        borderRadius: borderRadius.md,
        display: "grid",
        placeItems: "center",
        transition: transitions.create("margin", {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
        }),

        "& svg, svg g": {
            fill: "currentColor",
        },

        "& i": {
            color: active && (darkSidenav || sidenavColor) ? "inherit" : null,
        },
    };
}

const itemIcon = ({ palette: { white, gradients } }, { active }) => ({
    color: active ? white.main : gradients.dark.state,
});

function itemText(theme, ownerState) {
    const { typography, transitions, breakpoints, functions } = theme;
    const { miniSidenav, active } = ownerState;

    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { pxToRem } = functions;

    return {
        color: "inherit",
        marginLeft: pxToRem(4),

        [breakpoints.up("xl")]: {
            opacity: miniSidenav ? 0 : 1,
            maxWidth: miniSidenav ? 0 : "100%",
            marginLeft: miniSidenav ? 0 : pxToRem(4),
            transition: transitions.create(["opacity", "margin"], {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
            }),
        },

        "& span": {
            color: "inherit",
            fontWeight: active ? fontWeightMedium : fontWeightRegular,
            fontSize: size.sm,
            lineHeight: 0,
        },
    };
}

export { item, itemIconBox, itemIcon, itemText };
